export const CreateAttendee = async (eventDetails, attendee) => {
  const res = await fetch(`https://petros-global.com/ems/backend/attendees/create.php`, {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
    method: "POST",
    body: JSON.stringify({
      variables: {
        eventDetails,
        attendee,
      },
    }),
  });

  return res;
}

export const fetchAttendees = async (eventId) => {
  const res = await fetch("https://petros-global.com/ems/backend/attendees/fetchById.php?eventId=" + eventId, {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
  });

  const json = await res.json();

  return json;
}

export const updateAttendeeItem = async (updatedAttendee) => {
  const res = await fetch("https://petros-global.com/ems/backend/attendees/update.php", {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
    method: "POST",
    body: JSON.stringify({
      variables: {
        ...updatedAttendee,
        payments: JSON.stringify(updatedAttendee.payments),
      }
    })
  });

  return res;
}

export const updateAttendeeAttendance = async (updatedAttendee) => {
  const res = await fetch("https://petros-global.com/ems/backend/attendees/updateAttendance.php", {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
    method: "POST",
    body: JSON.stringify({
      variables: updatedAttendee
    })
  });

  return res;
}